<template>
    <div class="my-editor-main">
        <quill-editor class="my-editor" v-model="editorContent" :options="editorOptions"
            :disabled="isDisabled"></quill-editor>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '请输入正文内容或者选择AI生成'
        },
        options: {
            type: Object,
            default: () => ({
                theme: 'snow',
                modules: {
                    toolbar: false
                },
                placeholder: ''
            })
        }
    },
    data() {
        return {
            editorContent: this.value
        }
    },
    watch: {
        editorContent: {
            handler(newValue) {
                this.$emit('input', newValue)
            },
            deep: true
        },
        value: {
            handler(newValue) {
                this.editorContent = newValue
            },
            deep: true
        },
        isDisabled(newValue) {
            // 当传入的禁用状态改变时，可以在这里添加额外逻辑
            // console.log('禁用状态改变为:', newValue)
        }
    },
    computed: {
        editorOptions() {
            return {
                ...this.options,
                placeholder: this.placeholder
                // 可以在这里添加额外的动态配置
            }
        }
    },
    methods: {
        // 可以添加一些方法，例如获取编辑器内容等
        getEditorContent() {
            return this.editorContent
        }
    }
}
</script>

<style lang="scss" scoped>
.my-editor-main {
    height: 100%;
    font-family: Microsoft YaHei, Microsoft YaHei;
    white-space: pre-wrap !important;
}

.my-editor {
    color: #111111;
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
}

:deep(.ql-container.ql-snow) {
    border: none;
    height: 100%;
}

:deep(.quill-editor-container .ql-container) {
    border: none;

}

:deep(.quill-editor .ql-disabled p) {
    cursor: not-allowed;
}

:deep(.ql-editor) {
    padding: 0;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;

    /* IE/Edge */
    &::-webkit-scrollbar {
        display: none;
        /* Chrome/Safari/Edge */
    }
    // tab-size: 0;
    &.ql-blank::before {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-style: normal;
        text-transform: none;
        left: 0;
        top: 0;
        color: #c0c4cc;
        right: 0;
        position: absolute;
        font-size: 15px;
    }

    a {
        color: #111111 !important;
        text-decoration: none;
    }

    span {
        color: #111111;
        background-color: transparent !important;
    }
}

:deep(.quill-editor p) {
    font-size: 17px;
    color: #111111;
}
</style>